module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "createProj",
    attrs: {
      "md-open-from": "#createProj",
      "md-close-to": "#createProj"
    },
    on: {
      "open": _vm.fixContent,
      "close": _vm.startOver
    }
  }, [(_vm.user.active_pay) ? _c('md-stepper', {
    ref: "stepper",
    on: {
      "completed": _vm.closeDialog
    }
  }, [_c('md-step', {
    attrs: {
      "md-button-continue": "CREATE",
      "md-label": "CREATE",
      "md-editable": ""
    }
  }, [_c('create', {
    attrs: {
      "project": _vm.project
    }
  })], 1), _vm._v(" "), _c('md-step', {
    attrs: {
      "md-label": "COLLABORATORS"
    }
  }, [_c('collaborators', {
    attrs: {
      "project": _vm.project
    }
  })], 1), _vm._v(" "), _c('md-step', {
    attrs: {
      "md-label": "LAYERS"
    }
  }, [_c('layers', {
    attrs: {
      "project": _vm.project
    }
  })], 1)], 1) : _c('div', [_c('md-dialog-title', [_vm._v("Unable to create project")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("Free users are not able to create projects.")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a567628","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/modals/create-project.vue
// module id = 663
// module chunks = 2